
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gHoLN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d7a0ed7bce33c459$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $d7a0ed7bce33c459$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "\u6587\u5B57\u3092\u5165\u529B\u2026",
    'fabric.editor.editorAssistiveLabel': "\u30E1\u30A4\u30F3 \u30B3\u30F3\u30C6\u30F3\u30C4\u9818\u57DF\u3002\u5165\u529B\u3092\u958B\u59CB\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u307E\u3059\u3002",
    'fabric.editor.headingLink.toolbarHelpTitle': "\u30D8\u30EB\u30D7 \u30C0\u30A4\u30A2\u30ED\u30B0\u3092\u958B\u304F"
};

});


//# sourceMappingURL=ja.fff452b4.js.map
